<app-header [forceLightBackground]="true"></app-header>
<div class="contribution-setup">
  <div class="contribution-setup--layout">
    <ng-content></ng-content>
    <div class="contribution-setup--content">
      <app-page-header></app-page-header>
      <div class="contribution-container">
        <!-- Step 1 Template -->
        <ng-template #step1Template>
          <form [formGroup]="contributionForm">
            <!-- Step 1: Setup -->
            <div class="step-content step-1">
              <h2 class="step-title">{{ config.setupTitle }}</h2>
              
              <div class="form-fields">
                <div class="form-row">
                  <!-- Title Field -->
                  <div class="form-field col-6">
                    <label for="title" class="form-label">
                      Title <span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="title"
                      formControlName="title"
                      class="form-input"
                      [placeholder]="config.titlePlaceholder"
                      [class.error]="(contributionForm.get('title')?.invalid && contributionForm.get('title')?.touched) || titleAvailabilityStatus === 'not-available'"
                    />
                    <div
                      *ngIf="contributionForm.get('title')?.invalid && contributionForm.get('title')?.touched"
                      class="error-message"
                    >
                      Title is required
                    </div>
                    <!-- Title Availability Status -->
                    <div *ngIf="(config.type === 'dataset' || config.type === 'model') && contributionForm.get('title')?.value" class="title-availability-message">
                      <div *ngIf="isCheckingTitle" class="availability-checking">
                        Checking availability...
                      </div>
                      <div *ngIf="!isCheckingTitle && titleAvailabilityStatus === 'available'" class="availability-available">
                        <svg class="availability-icon availability-icon-tick" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="9" cy="9" r="8" fill="#4caf50" stroke="#4caf50" stroke-width="1"/>
                          <path d="M6 9L8 11L12 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        Title is available
                      </div>
                      <div *ngIf="!isCheckingTitle && titleAvailabilityStatus === 'not-available'" class="availability-not-available">
                        <svg class="availability-icon availability-icon-cross" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="9" cy="9" r="8" fill="#d32f2f" stroke="#d32f2f" stroke-width="1"/>
                          <path d="M6 6L12 12M12 6L6 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        Title is not available
                      </div>
                    </div>
                  </div>

                  <!-- Permission Dropdown with Checkboxes -->
                  <div class="form-field col-6">
                    <label for="permission" class="form-label">
                      Permission <span class="required">*</span>
                    </label>
                    <div class="custom-dropdown-wrapper">
                      <div
                        class="custom-dropdown-trigger"
                        [class.error]="contributionForm.get('permission')?.invalid && contributionForm.get('permission')?.touched"
                        [class.open]="isPermissionDropdownOpen"
                        (click)="togglePermissionDropdown()"
                      >
                        <div class="trigger-content">
                          <span
                            *ngIf="!contributionForm.get('permission')?.value"
                            class="placeholder"
                          >
                            Select permission
                          </span>
                          <span
                            *ngIf="contributionForm.get('permission')?.value"
                            class="permission-chip"
                            [class.permission-chip--public]="contributionForm.get('permission')?.value === 'Open'"
                            [class.permission-chip--restricted]="contributionForm.get('permission')?.value === 'Restricted'"
                          >
                            <img src="/public.svg" alt="" class="permission-chip__icon" aria-hidden="true" />
                            {{ getSelectedPermissionLabel() }}
                            <svg
                              class="chip-close-icon"
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              (click)="clearPermission($event)"
                            >
                              <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </span>
                        </div>
                        <svg
                          class="dropdown-arrow"
                          [class.rotated]="isPermissionDropdownOpen"
                          width="12"
                          height="8"
                          viewBox="0 0 12 8"
                          fill="none"
                        >
                          <path d="M1 1L6 6L11 1" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                      <div
                        *ngIf="isPermissionDropdownOpen"
                        class="custom-dropdown-panel"
                        (click)="$event.stopPropagation()"
                      >
                        <div
                          *ngFor="let option of permissionOptions"
                          class="dropdown-option"
                          (click)="selectPermission(option)"
                        >
                          <div class="checkbox-wrapper">
                            <input
                              type="checkbox"
                              [checked]="isPermissionSelected(option.value)"
                              class="checkbox-custom"
                              readonly
                            />
                          </div>
                          <span class="option-label">{{ option.label }}</span>
                        </div>
                      </div>
                    </div>
                    <div
                      *ngIf="contributionForm.get('permission')?.invalid && contributionForm.get('permission')?.touched"
                      class="error-message"
                    >
                      Permission is required
                    </div>
                  </div>
                </div>

                <!-- Metadata Option Selection -->
                <div class="metadata-options">
                  <div class="metadata-options__header">
                    <p class="metadata-options__label">Choose how you want to add metadata:</p>
                    
                  </div>
                  <div class="metadata-options__buttons">
                    <div
                      class="metadata-option-card"
                      [class.active]="contributionForm.get('metadataOption')?.value === 'enter'"
                    >
                      <div class="metadata-option-card__header">
                        <div class="metadata-option-card__icon">
                          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M18.5 2.5C18.8978 2.10218 19.4374 1.87868 20 1.87868C20.5626 1.87868 21.1022 2.10218 21.5 2.5C21.8978 2.89782 22.1213 3.43739 22.1213 4C22.1213 4.56261 21.8978 5.10218 21.5 5.5L12 15L8 16L9 12L18.5 2.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                      </div>
                      <div class="metadata-option-card__content">
                        <p class="metadata-option-card__description">
                          Manually define your metadata by filling up the form. Add titles, descriptions, field types, and schema details.
                        </p>
                      </div>
                      <div class="metadata-option-card__footer">
                         <button
                           type="button"
                           class="metadata-option-card__button"
                           [disabled]="isUpdateMode || !canEnableMetadataButtons()"
                           (click)="selectMetadataOption('enter')"
                           [attr.aria-label]="'Enter metadata manually'"
                         >
                           Enter metadata
                         </button>
                      </div>
                    </div>
                    <div class="metadata-options__divider">
                      <div class="metadata-options__divider-line"></div>
                      <div class="metadata-options__divider-content">
                        <span class="metadata-options__divider-text">OR</span>
                      </div>
                      <div class="metadata-options__divider-line"></div>
                    </div>
                    <div
                      class="metadata-option-card"
                      [class.active]="contributionForm.get('metadataOption')?.value === 'upload'"
                    >
                      <div class="metadata-option-card__header">
                        <div class="metadata-option-card__icon">
                          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M7 14L12 9L17 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12 9V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                      </div>
                      <div class="metadata-option-card__content">
                        <p class="metadata-option-card__description">
                          Quickly populate your metadata by uploading a ready-made JSON schema. Ideal for reusing standard formats or bulk entry.
                        </p>
                      </div>
                      <div class="metadata-option-card__footer">
                         <button
                           type="button"
                           class="metadata-option-card__button"
                           [disabled]="isUpdateMode || !canEnableMetadataButtons()"
                           (click)="selectMetadataOption('upload')"
                           [attr.aria-label]="'Upload metadata from JSON schema'"
                         >
                           Upload metadata
                         </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ng-template>

        <!-- Stepper Component -->
        <app-stepper
          [steps]="stepperSteps"
          [currentStep]="currentStep"
          [hideNextOnFirstStep]="true"
          (stepChange)="onStepChange($event)"
          (next)="onNext()"
          (previous)="onPrevious()"
        ></app-stepper>
      </div>
    </div>
  </div>
</div>
